"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireWildcard(require("cccisd-tabletop"));
var _resourceViewByView = _interopRequireDefault(require("./resourceViewByView.graphql"));
var _resourceViewByViewer = _interopRequireDefault(require("./resourceViewByViewer.graphql"));
var _resourceViewVisualization = _interopRequireDefault(require("./resourceViewVisualization.graphql"));
var _resourceViewViz = _interopRequireDefault(require("./resourceViewViz.js"));
var _logTableRenders = _interopRequireDefault(require("../../../helpers/logTableRenders.js"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var resourceViewTable = function resourceViewTable() {
  var maxDate = (0, _moment["default"])().format('YYYY-MM-DD');
  var minDate = (0, _moment["default"])().subtract(60, 'days').format('YYYY-MM-DD');
  var variables = {
    minDate: minDate,
    maxDate: maxDate
  };
  var byView = {
    query: _resourceViewByView["default"],
    rowKey: 'eventId',
    isAscentOrder: false,
    handle: 'resourceViewByView',
    visualize: {
      query: _resourceViewVisualization["default"],
      charts: _resourceViewViz["default"],
      variables: variables
    },
    columns: [{
      name: 'eventAt',
      label: 'View Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'resource.resourceId',
      label: 'Resource ID',
      hideInTable: true
    }, {
      name: 'resource.label',
      label: 'Resource',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].resourceLinkRender
    }, {
      name: 'url',
      label: 'Resource Center',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].linkRender
    }, {
      name: 'pawn.pawn.pawnId',
      label: 'Viewer ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'pawn.user.username',
      label: 'Username',
      sort: true,
      filter: true
    }]
  };
  var byViewer = {
    query: _resourceViewByViewer["default"],
    rowKey: 'pawn.pawnId',
    isAscentOrder: false,
    handle: 'resourceViewByViewer',
    visualize: {
      query: _resourceViewVisualization["default"],
      charts: _resourceViewViz["default"],
      variables: variables
    },
    columns: [{
      name: 'pawn.pawnId',
      label: 'Viewer ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'user.username',
      label: 'Username',
      sort: true,
      filter: true
    }, {
      name: 'eventCount',
      label: '# Views',
      sort: true,
      filter: true
    }, {
      name: 'eventSummary.minDate',
      label: 'First view',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'eventSummary.maxDate',
      label: 'Latest view',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "resourceViews",
    saveState: true,
    views: [{
      handle: 'resourceViewByView',
      title: 'Resource Views - by View',
      table: byView,
      buttons: [_cccisdTabletop.visualizeButton]
    }, {
      handle: 'resourceViewByViewer',
      title: 'Resource Views - by Viewer',
      table: byViewer
    }]
  }));
};
var _default = exports["default"] = {
  name: 'resources',
  title: 'Resource Views',
  content: resourceViewTable()
};